import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { Resource } from "i18next";
import api from "./axiosConfig";
import _ from "lodash";

const envName = process.env.REACT_APP_ENVIRONMENT_NAME;
export const getUITexts = async (): Promise<void> => {
  try {
    const bundles: Resource = await (await api.get("faultViewerTexts")).data;
    _.values(bundles).forEach((resourceLanguage, langIx) => {
      _.values(resourceLanguage).forEach((resourceKey, keyIx) => {
        i18n.addResourceBundle(
          _.keys(bundles)[langIx],
          _.keys(resourceLanguage)[keyIx],
          resourceKey
        );
      });
    });
  } catch (error) {
    console.log("Unable to fetch localizations. Running UI unlocalized.");
  }
};
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: envName === ".env" || envName === ".env.dev" ? true : false,
    fallbackLng: "en-US",
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    react: {
      useSuspense: true
    }
  });
export default i18n;
